import Monday from "../auth/useMonday.jsx";

class backgroundCache
{
    constructor(props)
    {
        //this.startCaching();
    }
    
    async startCaching()
    {
        //console.log("backgroundCache startCaching");
        var this_class = this;
        
        await Monday.getItemsFields(null, true, true);
        await Monday.getSubItemsFields(null, true, false);
        
        setTimeout(() => {
            this_class.startCaching();
        }, 10 * 60 * 1000);
    }
}

export default new backgroundCache();